module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Navigation/Route-5e829ec54d8ec57fe2a504a19394da1b.svg";